import { FIVE_MINUTES_IN_MS } from '~/constants'
import { TSessionDetails } from '~/features/auth/models'
import { ECognitoGroups } from '~/models/auth'
import AuthService from '~/services/auth'

export const AUTH_SESSION_QUERY_KEY = 'authSession'

export const queryKeys = {
  authSession: () => [AUTH_SESSION_QUERY_KEY],
}

export const queries = {
  authSession: () => ({
    queryKey: queryKeys.authSession(),
    queryFn: () =>
      AuthService.fetchAuthSession()
        .then(async (authSession) => {
          return {
            groups:
              (authSession?.tokens?.idToken?.payload[
                'cognito:groups'
              ] as ECognitoGroups[]) ?? [],
            email:
              (authSession?.tokens?.idToken?.payload.email as string) ?? '',
            cognitoUid: authSession?.userSub ?? '',
            accessToken: authSession?.tokens?.accessToken?.toString() ?? '',
          } as TSessionDetails
        })
        .catch(async () => {
          return {
            groups: [],
            email: '',
            cognitoUid: '',
            accessToken: '',
          } as TSessionDetails
        }),
    staleTime: FIVE_MINUTES_IN_MS,
    refetchInterval: FIVE_MINUTES_IN_MS,
  }),
}
